/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
import React, { useMemo } from "react";
import { useMsal } from "../hooks/useMsal";
import { useIsAuthenticated } from "../hooks/useIsAuthenticated";
import { getChildrenOrFunction } from "../utils/utilities";
import { InteractionStatus } from "@azure/msal-browser";
/**
 * Renders child components if user is unauthenticated
 * @param props
 */
export function UnauthenticatedTemplate({ username, homeAccountId, localAccountId, children, }) {
    const context = useMsal();
    const accountIdentifier = useMemo(() => {
        return {
            username,
            homeAccountId,
            localAccountId,
        };
    }, [username, homeAccountId, localAccountId]);
    const isAuthenticated = useIsAuthenticated(accountIdentifier);
    if (!isAuthenticated &&
        context.inProgress !== InteractionStatus.Startup &&
        context.inProgress !== InteractionStatus.HandleRedirect) {
        return (React.createElement(React.Fragment, null, getChildrenOrFunction(children, context)));
    }
    return null;
}
//# sourceMappingURL=UnauthenticatedTemplate.js.map